import { useContext } from "react";
import { GlobalIcon } from "get-life-storybook-ts";
import { I18nContext } from "../../../../../context/i18n.context";
import numberFormat from "../../../../../utils/Utils";
import { PendingCapitalI } from "../../../../../api/request/Lead/Interfaces/PolicyInterface";
import PendingCapitalLine from "./pendingCapital/PendingCapitalLine";

interface DashboardHeadingProps {
  section?: string;
  capital: number;
  pendingCapital?: PendingCapitalI | null;
}

const DashboardHeading = ({ section, capital, pendingCapital }: DashboardHeadingProps) => {
  const {
    state: { translate },
  } = useContext(I18nContext);

  const isProfile = section === "profile";
  const isPolicy = section === "policy";

  return (
    <div className="dashboard-heading">
      {isProfile && (
        <div className="dashboard-headingLabel">
          <p className="H4 font-bold">
            {translate("newDashboard.menu.profile.title")}
          </p>
          <p className="BodyM">
            {translate("newDashboard.menu.profile.description")}
          </p>
        </div>
      )}
      {isPolicy && (
        <div className="dashboard-headingLabel">
          <p className="H4 font-bold">
            {translate("newDashboard.menu.policy.title")}
          </p>
          <p className="BodyM">
            {translate("newDashboard.menu.policy.description")}
          </p>
        </div>
      )}
      {!isProfile && (
        <div className="dashboard-capital">
          <GlobalIcon iconName="ShieldLockIcon" size="XS" />
          <div className="dashboard-capitalLabel">
            <span className="BodyM">
              {translate("newDashboard.assuredCapital")}
            </span>
            <span className="H4">{numberFormat(capital, "capital")}</span>
            <PendingCapitalLine pendingCapital={pendingCapital} current={capital} style={{ margin: 0 }} />
          </div>
        </div>
      )}
    </div>
  );
};

export default DashboardHeading;
